import { ActionCreator } from 'redux';
import {
    IncrementCounterAction,
    LoadCounterAction
} from './types';

// Type these action creators with `: ActionCreator<ActionTypeYouWantToPass>`.
// Remember, you can also pass parameters into an action creator. Make sure to
// type them properly.

export const incrementCounter: ActionCreator<IncrementCounterAction> = (name: string) => ({
    type: '@@counter/INCREMENT',
    payload: {
        name,
    },
});

export const loadCounter: ActionCreator<LoadCounterAction> = (name: string, value: number) => ({
    type: '@@counter/LOAD',
    payload: {
        name,
        value
    },
});



// WEBPACK FOOTER //
// ./store/counter/actions.ts